import React, { useState } from 'react';
import './admin.css';
import LoginForm from '../../components/admin/LoginForm';

export default function Admin() {
  const adminUser = {
    email: 'admin@admin',
    password: 'Rigers777',
  };

  const [user, setUser] = useState({ name: '', email: '' });
  const [error, setError] = useState('');

  const Login = (details) => {
    console.log(details);
    if (
      details.email == adminUser.email &&
      details.password == adminUser.password
    ) {
      setUser({
        name: details.name,
        email: details.email,
      });
    } else {
      console.log('Detail do not match!');
      setError('Details do not match!');
    }
  };

  const sendAudioFile = (event) => {
    // if (event.target.files && event.target.files[0]) {
    //   const audio = event.target.files[0];
    //   setAudioFile(audio);
    // }
    console.log('AA', event.target.files[0]);
  };

  const Logout = () => {
    setUser({ name: '', email: '' });
  };

  return (
    <div className='my-reset'>
      {user.email != '' ? (
        <div className='welcome'>
          <h2>
            Welcome &nbsp; <span> {user.name} </span>
          </h2>
          <div className='form__group__file'>
            <h3>Update CV pdf!</h3>
            <input
              className='file__upload__admin'
              type='file'
              name='audio'
              onChange={sendAudioFile}
            />
          </div>
          <button className='admin__btn__logout' onClick={Logout}>
            Logout
          </button>
        </div>
      ) : (
        <LoginForm Login={Login} error={error} />
      )}
    </div>
  );
}
